





















import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppSelector from '@/components/AppSelector.vue'
import SearchUser from '@/mixins/search-queries/search-user'
import { casePriorityValues } from '@/modules/Case/helpers/case'
import { ICaseInfoInput } from '@/modules/Case/interfaces/case-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppTextarea
  }
})
export default class CaseFormInfo extends mixins(SearchUser) {
  @Prop({ type: Object as () => ICaseInfoInput }) value!: ICaseInfoInput

  casePriorityOptions = casePriorityValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
